import React, { useState, useEffect } from "react";
import * as moment from "moment";
import { FORMAT } from "web/components/utils/dateOfBirthValidation";
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';

import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import AlertModal from "web/components/AlertModal";

import DatePicker from "web/components/form-elements/DatePicker";

import TimePickerInput from "./TimePickerInput";

import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import Button from "web/components/Button";
import CloseIcon from "web/assets/images/CloseIcon.png";
import {
  getInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/inventoryRepostBidUtils";
import { Modal, ModalBody } from "reactstrap";
import "./placeBid.scss";
import {
  DateTimeWrapper,
  TimeWrapper,
} from "./placeBidStyle";
import { fetchLanguageContentNew } from 'redux/actions/language';

export default ({
  isOpen,
  toggle,
  title,
  link,
  response,
  myPostType,
  repostCallBack
}) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const accountType = localStorage.getItem("accountType");
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  const [pleaceBidText, setPleaceBidText] = useState('')

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    if (accountType === "Seller" || myPostType === "PostLoad") {
      setPleaceBidText(pageLanguageContents?.PlaceBidModal[1]?.Checkbox2)
    } else {
      setPleaceBidText(pageLanguageContents?.PlaceBidModal[0]?.Checkbox1)
    }
  }, [pageLanguageContents])

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
 
  const [postType, setPostType] = useState();

  useEffect(() => {
  }, []);

  let bidCloseTime = new Date(response?.postPreferences?.bidCloseTime).getDate()
  //let createdAt = new Date(response.createdAt).getDate()
  let getDateTime = bidCloseTime// - createdAt

  let getState= response?.userDetails?.state
  if(response?.userDetails?.state === "Washington" || !response?.userDetails?.state){
    getState="California"
  }
  const nDate = new Date().toLocaleString('en-US', {
    timeZone: 'US/' + timeZoneFun(getState)
  });

  let currentTimeBegin = new Date(nDate)

  let setBidTime;
  if (currentTimeBegin.getHours() === 0) {
    if (currentTimeBegin.getMinutes() === 0) {
      setBidTime = '00:00' + ':' + currentTimeBegin.getSeconds();
    } else {
      setBidTime = '00:' + currentTimeBegin.getMinutes() + ':' + currentTimeBegin.getSeconds();
    }
  } else {
    if (currentTimeBegin.getMinutes() === 0) {
      setBidTime = currentTimeBegin.getHours() + ':00' + ':' + currentTimeBegin.getSeconds();
    } else {
      setBidTime = currentTimeBegin.getHours() + ':' + currentTimeBegin.getMinutes() + ':' + currentTimeBegin.getSeconds();
    }
  }

  let bidCloseTimeSet;
  let requestDeliveryDateSet;
  if (getDateTime === 0) {
    bidCloseTimeSet = moment(new Date().setDate(new Date().getDate() + getDateTime)).format(FORMAT)
    requestDeliveryDateSet = moment(new Date(bidCloseTimeSet).setDate(new Date(bidCloseTimeSet).getDate() + 1)).format(FORMAT)
  } else {
    bidCloseTimeSet = moment(new Date().setDate(new Date().getDate() + getDateTime)).format(FORMAT)
    requestDeliveryDateSet = moment(new Date(bidCloseTimeSet).setDate(new Date(bidCloseTimeSet).getDate() + 2)).format(FORMAT)
  }

  const handleSubmit = async (props) => {
    let setbidTimeArr = props.values.requestedStartTime.split(":");
    let pickupStartTime = props.values.requestedStartTime;
    let pickupEndTimeArr = props.values.requestedEndTime.split(":");
    let pickupEndTime = props.values.requestedEndTime;

    if (pickupStartTime.length) {
      let setHours = setbidTimeArr[0];
      let setMinutes = setbidTimeArr[1];
      if (setbidTimeArr[0].length === 1) {
        setHours = 0 + setbidTimeArr[0];
      }
      if (setbidTimeArr[1].length === 1) {
        setMinutes = 0 + setbidTimeArr[1];
      }
      pickupStartTime = setHours + ":" + setMinutes;
    }

    if (pickupStartTime.length) {
      let setHours = pickupEndTimeArr[0];
      let setMinutes = pickupEndTimeArr[1];
      if (pickupEndTimeArr[0].length === 1) {
        setHours = 0 + pickupEndTimeArr[0];
      }
      if (pickupEndTimeArr[1].length === 1) {
        setMinutes = 0 + pickupEndTimeArr[1];
      }
      pickupEndTime = setHours + ":" + setMinutes;
    }

    repostCallBack(props.values.repostDate, pickupStartTime, pickupEndTime, setBidTime, props.values.repostBidCloseTime, props.values.bidTime)
  };


  return (
    <div className="alert-modal">
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={"static"}
        centered={true}
        className="placeBidContainer"
      >
        <div className="modal-content">
          <div className="header">
            <Button
              handleClick={() => {
                toggle(!isOpen);
              }}
            >
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3>Repost Your Pallet Inventory</h3>
            <p style={{ fontSize: '16px' }}>
              Please select the amount of time you would like to run your posted inventory on the marketplace.
            </p>
          </div>
          <ModalBody>
            <div className="placeBidBody">
              {loaderVisible && <Spinner />}
              {response && <Formik
                initialValues={getInitialValues(response)}
                validationSchema={VALIDATION_SCHEMA()}
                onSubmit={(values) => { }}
              >
                {(props) => {
                  return (
                    <>
                      <Form>
                        <div className="section">
                          <div className="row ">
                            <div className="mt-0  col-md-4 col-sm-12">
                              <p>Bid Close Date</p>
                              <DatePicker
                                name='repostBidCloseTime'
                                // type={"Post"}
                                type="DatesDisabled"
                              />
                            </div>
                            <div className="col-md-8 col-sm-12">
                              <div className="mt-0">
                                <p>Bid Close Time</p>
                              </div>
                              <div style={{ 'width': '168px' }}>
                                <TimePickerInput
                                  name="bidTime"
                                  type="time"
                                  locationState={response?.userDetails?.state? response?.userDetails?.state:'California'}
                                  showErrorMessages={true}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="btnSection">
                              <Button
                                type="app-green-button"
                                name="createGroup"
                                handleClick={() => {
                                  handleSubmit(props);
                                }}
                              >
                                {pageLanguageContents?.PlaceBidModal[9]?.Confirm}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  );
                }}
              </Formik>}
            </div>
          </ModalBody>
        </div>
      </Modal>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        content={modalContent}
        link={(modalLink === '/view-my-offers-on-pallet-inventory' || modalLink === '/view-my-bids-on-pallet-needs') ? "" : modalLink}
        alertType={modalLink === '/view-my-offers-on-pallet-inventory' ? "MyOfferInventoryBids" : modalLink === '/view-my-bids-on-pallet-needs' ? "MyOfferPostBids" : ""}
        postType={postType}
        inventoryCallBackAlert={() => {
          let obj = {
            postType: "PostInventory",
            type: "bidsPalletOffers",
            activePage: 'PostInventory',
            // activeSearch:'Dashboard',
              expanded: 'panel1'
          }
          dispatch({ type: 'BIDS_INVENTORY', payload: obj })
          history.push({
              pathname: modalLink,
          })
          // history.push({
          //   pathname: modalLink,
          //   search: "?postType=PostInventory&type=bidsPalletOffers&activePage=PostInventory&expanded=panel1",
          // });
        }}
        // postCallBackAlert={() => {
        //   let obj = {
        //     postType: "PostLoad",
        //     type: "bidsPalletNeeds",
        //     activePage: 'PostLoad',
        //     expanded: 'panel2'
        //   }
        //   dispatch({ type: 'BID_NEEDS', payload: obj })

        //   history.push({
        //     pathname: modalLink,
        //     // search: '?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2',
        //   })
        //   // history.push({
        //   //   pathname: modalLink,
        //   //   search: "?postType=PostLoad&type=bidsPalletNeeds&activePage=PostLoad&expanded=panel2",
        //   // });
        // }}
      />
    </div>
  );
};
